<!--
/*******************************************************************************
*@ 컴포넌트명   : mmrSalaryApplyRsultInqRpt.vue
*@ 컴포넌트설명 : 미얀마 급여이체내역 조회 - 상세내역
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" class="popup" @cancel="popupClose">
      <template #subtitle>
        <h2>{{ /*거래내역*/ $t("PCOP-02-02-04-19") }}</h2>
      </template>
      <template #content>
        <template>
          <dl class="dlist dlist-item--type4">
            <dt>{{ $t(/*급여이체 관리번호*/ $t("MCOM-0000203")) }}</dt>
            <dd>{{ detailInfo.salryTrsaccMgtNo }}</dd>
            <dt>{{ $t(/*출금계좌번호*/ "PCOP-02-03-03-06") }}</dt>
            <dd>{{ detailInfo.drwotAcno }}</dd>
            <dt>{{ /*총 이체금액*/ $t("MCOM-0000201") }}</dt>
            <dd>
              MMK
              {{
                $num(
                  _.map(detailInfo.outItem.gridDtail, v => {
                    const trsaccAmt = v.trsaccAmt;
                    return trsaccAmt;
                  }).reduce((a, b) => a + b, 0),
                )
              }}
            </dd>
            <dt>{{ /*총 이체 수수료*/ $t("MCOM-0000202") }}</dt>
            <dd>
              MMK
              {{
                $num(
                  _.map(detailInfo.outItem.gridDtail, v => {
                    const feeAmt = v.feeAmt;
                    return feeAmt;
                  }).reduce((a, b) => a + b, 0),
                )
              }}
            </dd>
            <dt>{{ /*총 건수*/ $t("MCOM-0000200") }}</dt>
            <dd>{{ $num(detailInfo.outItem.totalInquryCnt1, 0) }}</dd>
            <dt>{{ /*등록일*/ $t("PCOP-02-03-05-26") }}</dt>
            <dd>{{ $getGlobalDateFmt(detailInfo.regiYMS) }}</dd>
            <dt>{{ /*이체일*/ $t("MCOM-0000204") }}</dt>
            <dd>{{ $getGlobalDateFmt(detailInfo.salryTrsaccYmd) }}</dd>
          </dl>
          <!-- 이체 결과 부분-->
          <template v-for="(list, index) in detailInfo.outItem.gridDtail">
            <div class="box-white -type4" :key="index">
              <div class="header">
                <div class="title">
                  {{ list.mnrcvAcno }}({{ list.cncycd }})
                  <!--처리 상태-->
                  <template>
                    <div class="state normal" v-if="'0|1|2|4'.includes(list.brncoSalryTranStusDstcd)">
                      {{ $t(`${list.brncoSalryTranStusDstcd}_mmrSalary`) }}
                    </div>
                    <div class="state warning" v-else-if="'3|9'.includes(list.brncoSalryTranStusDstcd)">
                      {{ $t(`${list.brncoSalryTranStusDstcd}_mmrSalary`) }}
                    </div>
                    <div class="desc">
                      <div>({{ list.tranStusCtnt == "" ? "-" : list.tranStusCtnt }})</div>
                    </div>
                  </template>
                  <!--처리상태 END-->
                </div>
                <div class="desc">
                  <div class="item account">{{ list.trsaccDraweName }}</div>
                </div>
              </div>
              <div class="content">
                <div class="account-info -type3">
                  <div class="item sub">
                    <div class="cont">
                      <span class="tit">{{ $t(/*은행명*/ "PCOP-02-03-03-11") }}</span>
                      <span class="dec">{{ list.bnkName }}</span>
                    </div>
                    <div class="cont">
                      <span class="tit">{{ /*이체금액*/ $t("PCOP-02-03-03-12") }}</span>
                      <span class="dec">{{ list.cncycd }} {{ $num(list.trsaccAmt) }}</span>
                    </div>
                    <div class="cont">
                      <span class="tit">{{ /*수수료*/ $t("PCOP-02-03-03-13") }}</span>
                      <span class="dec" v-if="list.feeAmt != null">{{ list.cncycd }} {{ $num(list.feeAmt) }}</span>
                      <span class="dec" v-else>{{ list.cncycd }} {{ $num(0) }}</span>
                    </div>
                    <div class="cont">
                      <span class="tit">{{ $t(/*비고*/ $t("MPAY-02-01-25-13")) }}</span>
                      <span class="dec">{{ list.inotBasiSumryCtnt }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <!-- 이체 결과 End -->
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="popupClose()">{{ /*확인*/ $t("MPAY-04-01-10-21") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
